export class BaseState {
  initialized: boolean;
}
